import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  TextField,
  CircularProgress,
  Chip,
  InputAdornment,
  Avatar,
} from '@mui/material';
import { useStateValue } from '../../../contexto/store';
import {
  Search as SearchIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Person as PersonIcon,
} from '@mui/icons-material';
import {
  obtenerCerradosGanados,
  obtenerCerradosPerdidos,
  obtenerPresupuestosAsignados,
} from '../../../actions/PresupuestosAction';
import TPresupuestos from '../TPresupuestos';
export function MisPresupuestos(props) {
  //const mounted = useRef(true);

  //eslint-disable-next-line
  const [{ sesionUsuario }, distpatch] = useStateValue();
  const [term, setTerm] = useState('');
  const [radioValor, setRadioValor] = useState('SinProcesar');
  const [Datap, setDatap] = useState([]);
  const [idUsu, setIdUsu] = useState('');
  const [datosCargados, setDatosCargados] = useState(false);
  const radioValorHandleChange = (event) => {
    setRadioValor(event.target.value);
  };
  // const irANuevoPresupuesto = () => {
  //   props.history.push('/nuevoPresupuesto');
  // };
  useEffect(() => {
    const usuario = sesionUsuario.usuario.userName;
    switch (radioValor) {
      case 'SinProcesar':
        obtenerPresupuestosAsignados(usuario).then((response) => {
          if (response.status === 200) {
            setDatap(response.data);
            setIdUsu('SPV');
            setDatosCargados(true);
          } else {
            console.log('ERROR EN OBTENER PRESUPUESTOS SIN PROCESAR');
          }
        });
        break;
      case 'CerradosGanados':
        obtenerCerradosGanados(usuario).then((response) => {
          if (response.status === 200) {
            setDatap(response.data);
            setIdUsu('CGV');
            setDatosCargados(true);
          } else {
            console.log('ERROR EN OBTENER PRESUPUESTOS CG');
          }
        });
        break;
      case 'CerradosPerdidos':
        obtenerCerradosPerdidos(usuario).then((response) => {
          if (response.status === 200) {
            setDatap(response.data);
            setIdUsu('CPV');
            setDatosCargados(true);
          } else {
            console.log('ERROR EN OBTENER PRESUPUESTOS CP');
          }
        });
        break;
      // case 'Anulados':
      //   obtenerAnulados(usuario).then((response) => {
      //     if (response.status === 200) {
      //       setDatap(response.data);
      //       setIdUsu('AV');
      //       setDatosCargados(true);
      //     } else {
      //       console.log('ERROR EN OBTENER PRESUPUESTOS A');
      //     }
      //   });
      //   break;
      // case 'Eliminados':
      //   obtenerEliminados(usuario).then((response) => {
      //     if (response.status === 200) {
      //       setDatap(response.data);
      //       setIdUsu('EV');
      //       setDatosCargados(true);
      //     } else {
      //       console.log('ERROR EN OBTENER PRESUPUESTOS E');
      //     }
      //   });
      //   break;
      default:
        console.log('ERROR EN RADIO');
    }
  }, [radioValor, sesionUsuario]);

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header personalizado con avatar */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          color: 'white',
          p: 3,
          mb: 3,
          borderRadius: 2,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -20,
            right: -20,
            opacity: 0.2,
            transform: 'rotate(-15deg)',
          }}
        >
          <AssignmentIcon sx={{ fontSize: 120 }} />
        </Box>
        <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar
            sx={{
              width: 56,
              height: 56,
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              border: '3px solid rgba(255, 255, 255, 0.3)',
            }}
          >
            <PersonIcon sx={{ fontSize: 32 }} />
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
              Mis Presupuestos
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {sesionUsuario.usuario.nombrecompleto}
            </Typography>
          </Box>
          <Chip
            label={`${Datap.length} presupuestos`}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              fontWeight: 600,
              fontSize: '0.9rem',
            }}
          />
        </Box>
      </Paper>

      {/* Barra de búsqueda */}
      <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar por código, cliente, total..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
            },
          }}
        />
      </Paper>

      {/* Filtros con RadioGroup */}
      <Paper elevation={1} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: 'primary.main' }}>
          Filtrar por Estado
        </Typography>
        <RadioGroup
          row
          value={radioValor}
          onChange={radioValorHandleChange}
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <FormControlLabel
            value="SinProcesar"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <HourglassEmptyIcon sx={{ fontSize: 20, color: 'warning.main' }} />
                <Typography>Sin Procesar</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="CerradosGanados"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CheckCircleIcon sx={{ fontSize: 20, color: 'success.main' }} />
                <Typography>Cerrados Ganados</Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="CerradosPerdidos"
            control={<Radio />}
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CancelIcon sx={{ fontSize: 20, color: 'error.main' }} />
                <Typography>Cerrados Perdidos</Typography>
              </Box>
            }
          />
         
        </RadioGroup>
      </Paper>

      {/* Tabla de Presupuestos */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        {datosCargados ? (
          <TPresupuestos rows={Datap} termp={term} idUsu={idUsu} />
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 8,
              gap: 2,
            }}
          >
            <CircularProgress size={48} />
            <Typography variant="body1" color="text.secondary">
              Cargando tus presupuestos...
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  );
}
